import * as tslib_1 from "tslib";
import get from 'lodash/get';
import { getDeviationType } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
var textualTypes = [
    DeviationTypes.JOURNAL,
    DeviationTypes.LITERATURE,
    DeviationTypes.COMMISSION,
    DeviationTypes.POLL,
    DeviationTypes.STATUS,
];
function filterByType(types, stream, exclude, minLength) {
    if (exclude === void 0) { exclude = false; }
    if (minLength === void 0) { minLength = 1; }
    if (!stream || !stream.length) {
        return [];
    }
    var includeOrNot = function (array, item) {
        return exclude ? !array.includes(item) : array.includes(item);
    };
    var filtered = stream.filter(function (dev) { return dev && includeOrNot(types, getDeviationType(dev)); });
    return filtered.length < minLength ? [] : filtered;
}
export var ABOVE_FOLD_SECTION_COUNT = 2;
export function sliceToEven(stream, maxLength) {
    if (maxLength === void 0) { maxLength = 6; }
    return sliceToDivisible(stream, 2, maxLength);
}
export function sliceToDivisible(stream, divideBy, maxLength) {
    if (stream.length < divideBy) {
        return [];
    }
    var length = Math.floor(Math.min(maxLength, stream.length) / divideBy) * divideBy;
    return stream.slice(0, length);
}
export function filterRelatedStreams(sourceDeviation) {
    var relatedStreams = tslib_1.__assign({}, (sourceDeviation.extended && sourceDeviation.extended.relatedStreams));
    var deviationType = getDeviationType(sourceDeviation);
    var recommended = relatedStreams.recommended, collections = relatedStreams.collections, loveSuggestion = relatedStreams.loveSuggestion;
    if (deviationType === DeviationTypes.JOURNAL) {
        relatedStreams.recommendedJournals = filterByType([DeviationTypes.JOURNAL], recommended);
        relatedStreams.recommended = [];
    }
    if (deviationType === DeviationTypes.LITERATURE) {
        relatedStreams.recommendedLiterature = filterByType([DeviationTypes.LITERATURE], recommended);
        relatedStreams.recommended = [];
    }
    ['gallery', 'recommended', 'recent', 'popular'].forEach(function (streamKey) {
        relatedStreams[streamKey] = filterByType(textualTypes, relatedStreams[streamKey], true, 2);
    });
    if (collections) {
        relatedStreams.collections = collections
            .map(function (collection) { return (tslib_1.__assign({}, collection, { deviations: filterByType(textualTypes, collection.deviations, true, 2) })); })
            .filter(function (collection) { return collection.deviations.length; });
    }
    if (loveSuggestion && !loveSuggestion.loading) {
        var textSuggestions = filterByType(textualTypes, loveSuggestion.deviations, false, 1);
        if (textualTypes.includes(deviationType) && textSuggestions.length) {
            relatedStreams.loveSuggestion.deviations = textSuggestions;
        }
        else {
            relatedStreams.loveSuggestion.deviations = filterByType(textualTypes, loveSuggestion.deviations, true, 1);
        }
    }
    ['recommendedJournals', 'moreJournals', 'morePolls', 'latestStatus'].forEach(function (streamKey) {
        relatedStreams[streamKey] = filterByType(textualTypes, relatedStreams[streamKey]);
    });
    return relatedStreams;
}
export function getSidebarSections(deviation) {
    var type = getDeviationType(deviation);
    var streams = get(deviation, 'extended.relatedStreams', {});
    switch (type) {
        case DeviationTypes.POLL:
            return ['morePolls', 'gallery'];
        case DeviationTypes.STATUS:
            return ['latestStatus', 'gallery'];
        case DeviationTypes.JOURNAL:
            return streams.moreJournals && streams.moreJournals.length
                ? [
                    'moreJournals',
                    'loveSuggestion',
                    'recommendedJournals',
                    'collections',
                    'groups',
                    'gallery',
                    'recent',
                    'popular',
                ]
                : [
                    'gallery',
                    'loveSuggestion',
                    'recommendedJournals',
                    'collections',
                    'groups',
                    'recent',
                    'popular',
                ];
        case DeviationTypes.LITERATURE:
            return streams.moreLiterature && streams.moreLiterature.length
                ? [
                    'moreLiterature',
                    'loveSuggestion',
                    'recommendedLiterature',
                    'collections',
                    'groups',
                    'gallery',
                    'recent',
                    'popular',
                ]
                : [
                    'gallery',
                    'loveSuggestion',
                    'recommendedLiterature',
                    'collections',
                    'groups',
                    'recent',
                    'popular',
                ];
        default:
            return ['gallery', 'collections', 'recommended', 'groups'];
    }
}
export function getAboveFoldSections(deviation) {
    var sections = getSidebarSections(deviation);
    // some sections are derived from backend sections, some are client only, some need decamelizing...
    var sectionMap = {
        loveSuggestion: false,
        recommendedJournals: 'recommended',
        recommendedLiterature: 'recommended',
        moreJournals: 'more_journals',
        moreLiterature: 'more_literature',
        morePolls: 'more_polls',
        latestStatus: 'latest_status',
    };
    return sections
        .map(function (section) {
        return sectionMap.hasOwnProperty(section)
            ? sectionMap[section]
            : section;
    })
        .filter(function (section) { return !!section; })
        // take top two
        .slice(0, ABOVE_FOLD_SECTION_COUNT);
}
//# sourceMappingURL=helpers.js.map